var _circle, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecurringWithdrawalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#E1EBF6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontSize: 22,
    fontWeight: 400,
    fill: "#323232",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "\n    $\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringWithdrawalIcon);
export default __webpack_public_path__ + "static/media/RecurringWithdrawalIcon.6dfaea3e6a4725fde2355623363eed3d.svg";
export { ForwardRef as ReactComponent };